// src/Routes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Seasons from './pages/Seasons';
import Nominations from './pages/Nominations';
import LeaderboardPage from './pages/LeaderboardPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FeedbackPage from './pages/FeedbackPage';
import WorldCup2026 from './pages/WorldCup2026';  

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/seasons" element={<Seasons />} />
      <Route path="/nominations" element={<Nominations />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/feedback" element={<FeedbackPage />} />
      <Route path="/world-cup-2026" element={<WorldCup2026 />} />
    </Routes>
  );
};

export default AppRoutes;